import aboutpic from "./imageData/aun_img.png"
import mamaearth from "./imageData/mamaearth.png"
import sephora from "./imageData/sephora.png"
import timely from "./imageData/timely.png"

const header = {
  homepage: 'https://github.com/aun0545088',
  title: 'MERN',
}

const about = {
  photo:aboutpic,
  name: 'Aun Mohammad',
  role: 'Full stack Web developer',
  description:
    "Hello! I am Aun Mohammad, a full-stack web developer, with a passion to explore the coding world and add new technologies to my skill set. I love to solve problems and find a way out in challenging situations, whether in struggling with writing a line of code or dealing with real-life issues. I have around two years' experience of working as an associate consultant and now I am looking forward to starting my carrer as a software developer and refining my skills with the right company",
  resume: 'https://drive.google.com/file/d/1iyQkmB8vxUj7xD1YUBDDhFIKN9uQCH4K/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/aun-mohammad-931b5b11b/',
    github: 'https://github.com/aun0545088',
  },
}

const projects = [
  {
    name: 'Timely',
    image:timely,
    description:
      'Timely is an award-winning, AI-powered time tracking software that automates company time tracking and timesheet creation.',
    stack: ['React', 'Redux', 'Express','Node','MongoDB','ChakraUI'],
    sourceCode: 'https://github.com/aun0545088/Just-Books-790',
    livePreview: 'https://timely-clone.netlify.app/',
  },
  
  {
    name: 'Mamaearth',
    image:mamaearth,
    description:
      'It is one of the leading companies or a brand which intends to make the lives of mums & expectant mums better and more beautiful. A brand that welcomes all babies to a healthy and safe world.',
    stack: ['React','Redux','JavaScript','API','ChakraUI'],
    sourceCode: 'https://github.com/aun0545088/Clone_MamaEarth',
    livePreview: 'https://clone-mamaearth.netlify.app/',
  },
  {
    name: 'Sephora',
    image:sephora,
    description:
      "Sephora.com is leading E-Commerce website for all type of cosmetic products such as makeup, skin care, hair, 'fragrance's' and tools and brush.",
    stack: ['HTML', 'CSS', 'JavaScript','Local Storage','API'],
    sourceCode: 'https://github.com/aun0545088/Clone-of-Sephora.com',
    livePreview: 'https://peaceful-dodol-946a2a.netlify.app/index.html',
  },
  
]

const skills = [
  {title:'HTML',icon:'https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_1280.png'},
  {title:'CSS',icon:'https://cdn-icons-png.flaticon.com/512/919/919826.png'},
  {title:'JavaScript',icon:'https://icon-library.com/images/javascript-icon-png/javascript-icon-png-23.jpg'},
  {title:'Node JS',icon:'https://icon-library.com/images/node-js-icon/node-js-icon-8.jpg'},
  {title:'Express JS',icon:'https://blog.logrocket.com/wp-content/uploads/2020/12/express-middlewares-complete-guide.png'},
  {title:'PHP',icon:'https://pbs.twimg.com/media/EKdH0WYXUAAlSgf.png'},
  {title:'MySQL',icon:'https://d1.awsstatic.com/asset-repository/products/amazon-rds/1024px-MySQL.ff87215b43fd7292af172e2a5d9b844217262571.png'},
  {title:'MongoDB',icon:'https://cdn.icon-icons.com/icons2/2415/PNG/512/mongodb_plain_wordmark_logo_icon_146423.png'},
  {title:'React',icon:'https://icon-library.com/images/react-icon/react-icon-29.jpg'},
  {title:'Redux',icon:'https://miro.medium.com/max/624/1*SRL22ADht1NU4LXUeU4YVg.png'},
  {title:'Chakra UI',icon:'https://pbs.twimg.com/profile_images/1244925541448286208/rzylUjaf_400x400.jpg'},
  {title:'Git',icon:'https://icon-library.com/images/git-icon/git-icon-6.jpg'},
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'aun0545088@gmail.com',
  linkedin: 'https://www.linkedin.com/in/aun-mohammad-931b5b11b/',
  github: 'https://github.com/aun0545088'
}

export { header, about, projects, skills, contact }
